<div class="card bg-card-new card-radius-06 border-0" *ngIf="orders">
    <div class="card-header">
        <h4>{{"order_history"|translate}}</h4>
    </div>
    <div class="card-table py-4 px-6">
        <div class="table-responsive-sm">
            <table>
                <thead>
                <tr>
                    <th>{{"order"|translate}}</th>
                    <th>{{"company"|translate}}/{{"professional"|translate}}</th>
                    <th>{{"date"|translate}}</th>
                    <th>{{"status"|translate}}</th>
                    <th>{{"total"|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let order of orders" [routerLink]="'/account/orders/' + order.orderId" class="cursor:pointer">
                    <td><a [routerLink]="'/account/orders/' + order.orderId" class="color-accent">#{{ order.orderId }}<mat-icon class="mx-2 color-accent" color="warn" *ngIf="siteService?.features?.orderMessages && order.unreadUserMessages"> message</mat-icon></a></td>
                    <td>{{ translateHelper.localize(order.companyData?.name) || translateHelper.localize(order.professionalData?.profession?.title) || order.professionalData?.name }}</td>
                    <td>{{ order.creationDate |date }}</td>
                    <td>{{ translateHelper.localize(order?.orderStatusData?.name || order?.statusData?.name) || '' }}</td>
                    <td>{{ order.total | currencyConvert : order?.currencyMeta?.code }} {{"for"|translate}} {{ order.quantity }} {{"items"|translate}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="paginationOrderCount > 1">
        <div class="card-footer">
            <app-pagination (pageChange)="updateOrdersList($event)"  [total]="paginationOrderCount"></app-pagination>
        </div>
    </div>
</div>
